import { render, staticRenderFns } from "./NewServer100.vue?vue&type=template&id=2d740990&scoped=true&"
import script from "./NewServer100.vue?vue&type=script&lang=js&"
export * from "./NewServer100.vue?vue&type=script&lang=js&"
import style0 from "./NewServer100.vue?vue&type=style&index=0&id=2d740990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d740990",
  null
  
)

export default component.exports